module.exports = __webpack_public_path__ + "img/IMG_8991.f2b7fec3.jpg";